import { v as bvVar } from 'bv';
import GameLogoRedux from './game_logo_redux';

const GameLogo = () => (bvVar('casinoV2').logos
  ? GameLogoRedux
  : null);

export default GameLogo;
